const ContentAnalysis = () =>
  import(
    /* webpackChunkName: "contentAnalysis" */ '../views/ContentAnalysis.vue'
  )
const ContentAnalysisDetail = () =>
  import(
    /* webpackChunkName: "contentAnalysisDetail" */ '../views/ContentAnalysisDetail.vue'
  )

const AnalysisRoute = [
  {
    path: '/analyst',
    redirect: { name: 'analysis' },
  },
  {
    path: '/update',
    name: 'analysis',
    component: ContentAnalysis,
    meta: {
      requiresAuth: true,
      hiddeMenu: false,
      navBar: true,
      navBarBack: false,
      title: 'Analysis',
      backLink: 'dashboard',
    },
  },
  {
    path: '/update/detail/:id',
    name: 'analysisdetail',
    component: ContentAnalysisDetail,
    meta: {
      requiresAuth: true,
      hiddeMenu: true,
      navBar: true,
      navBarBack: true,
      title: 'Detail Analysis',
      backLink: 'analysis',
    },
  },
]

export default AnalysisRoute
